<host-calendar-layout
  (onDatesChange)="onHorizontalScroll($event)"
  (onScrollToBottom)="onCalendarScrollToBottom.emit($event)"
  #gridContainer>
  <!-- left-top -->
  <ng-container cl-left-top>
    <div class="border-b border-solid border-c-gb h-[50px]">
      <ng-content select=".filter-tpl"></ng-content>
    </div>
    <div class="px-[10px] leading-[24px] text-[10px] text-c-l2">
      {{ "word.empty_house" | translate }}
    </div>
  </ng-container>

  <!-- right-top -->
  <ng-container cl-right-top>
    <!-- 日期选择指示器 -->
    @if (selectStatus !== "none") {
      <div class="select-bar" [ngStyle]="selectedRectStyle"></div>
    }
    <!-- 换房取消按钮 -->
    @if (changeOrderBelongedHouseStatus === "selecting") {
      <div class="change-order-house-bar" [ngStyle]="changeOrderBelongedHouseRectStyle">
        <div class="change-order-house-cancel" (click)="endChangeOrderBelongedHouse()">
          {{ "calendar.pop.cancel_change_house" | translate }}
        </div>
      </div>
    }
  </ng-container>
  <ng-template #availableCount let-date="date">{{ getFreeHouseCount(date) }}</ng-template>

  <!-- left-bottom -->
  <ng-container cl-left-bottom>
    @for (type of listOfHouses(); track type.p_id) {
      <host-status-left-house-group
        [showTitle]="calendarType === 'complex'"
        [houseType]="type"
        (onClickUpdateCleanStatus)="onClickUpdateCleanStatus.emit($event)"></host-status-left-house-group>
    }
  </ng-container>

  <!-- right-bottom -->
  <ng-template #calendar let-listOfDatesInView="listOfDatesInView" let-cursor="cursor">
    @for (type of listOfHouses(); track type.p_id) {
      <!-- 日历行 - 组头 -->
      <ng-container *ngIf="calendarType === 'complex'">
        <div class="header-row relative text-m flex flex-row">
          <!-- 加载占位符 - 左 -->
          <div class="pr-2" [style.width]="cursor * cellWidth">
            <div class="h-[5px] w-full bg-c-gb rounded mt-[12px] animate-pulse"></div>
          </div>

          @for (date of listOfDatesInView; track date.date) {
            <host-status-right-calendar-cell
              [hostClass]="{
                '!border-l-[#ced5df]': date.day === 0,
                '!border-l-[#48ca93]': date.isCurrentDay
              }"
              [hostStyle]="{ width: cellWidth }"
              [isInternational]="isInternational"
              [houseCount]="getFreeHouseCountByType(type.p_id, date.date)"
              [house]="type"
              [showOversale]="housesOversaleMap?.['type']?.[type.p_id]?.[date.date]"
              [inventoryDiffInfo]="inventoryDiffMap[type.p_id]?.[date.date]"
              (click)="onClickTypeCell(type, date)"
              (mouseenter)="onHoverTypeCell(type, date)"></host-status-right-calendar-cell>
          }

          <!-- 加载占位符 - 右 -->
          <div class="pl-2 flex-1">
            <div class="h-[5px] w-full bg-c-gb rounded mt-[12px] animate-pulse"></div>
          </div>
          <!-- 房型日期选择框以及操作气泡 -->
          <div
            *ngIf="selectStatus !== 'none' && listOfSelectedData['id'] === type.p_id"
            class="select-rect house-type"
            [ngStyle]="selectedRectStyle"></div>
          <div
            *ngIf="selectStatus === 'done' && listOfSelectedData['id'] === type.p_id"
            class="operate-pop house-type horizontal"
            [style.left]="selectedRectStyle.left + selectedRectStyle.width">
            <div class="content">
              <div class="inner">
                <div class="item" (click)="_setHouseTypeInventory(type.p_id)">
                  {{ "component.multi_house_calendar.syn_channel_inventory" | translate }}
                  <!-- 同步渠道库存 -->
                </div>
              </div>
              <div class="arrow"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- 日历行 - 房间 -->
      @for (house of type.p_children; track house.c_id; let first=$first, last=$last) {
        <div class="calendar-row flex flex-row" [ngClass]="{ 'first-row': first, 'last-row': last }">
          <!-- 订单条 -->
          @for (reservation of reservationMap[house.c_id]; track reservation.code) {
            <host-reservation-bar
              [class.with-safe-area]="first && calendarType !== 'complex'"
              [reservation]="reservation"
              [isSelected]="selectedReservationCode === reservation.code"
              [isRelatedSelected]="
                selectedReservationCode &&
                selectedReservationCode !== reservation.code &&
                selectedReservationOrderCode === reservation.__orderCode
              "
              [cellWidth]="cellWidth"
              (onClickReservation)="_selectReservation(reservation.code)"
              (onClickChangeHouse)="startChangeOrderBelongedHouse(reservation)"
              (onClickExtendStay)="extendStayForReservation(reservation.code)"
              (onClickCreateTask)="
                createTask($event, reservation.check_out, reservation.house_id)
              "></host-reservation-bar>
          }

          <!-- 操作气泡 -->
          <div
            class="operate-pop"
            *ngIf="selectStatus === 'done' && listOfSelectedData['id'] === house.c_id"
            [style.left]="selectedRectStyle.left + selectedRectStyle.width - cellWidth / 2">
            <div class="content">
              <div class="inner">
                <div class="item" (click)="_changeTab('manual-order')">
                  {{ "calendar.pop.add_order" | translate }}
                  <!-- 录入订单 -->
                </div>
                <!-- 小时单 -->
                <div
                  *ngIf="selectedCellDates.head.isSame(selectedCellDates.last, 'd')"
                  class="item"
                  (click)="_displayHourReservationSidebar($any(listOfSelectedData), selectedCellDates)">
                  {{ "calendar.pop.hour_reservation" | translate }}
                </div>
                <ng-container *ngIf="dataOfShortcutPop.status !== 'past'">
                  <div
                    class="item"
                    (click)="changeHouseAvailable(1)"
                    *ngIf="dataOfShortcutPop.status === 'diff' || dataOfShortcutPop.status === 'close'">
                    {{ "calendar.pop.status_on" | translate }}
                    <!-- 打开 -->
                  </div>
                  <div
                    class="item"
                    (click)="changeHouseAvailable(0)"
                    *ngIf="dataOfShortcutPop.status === 'diff' || dataOfShortcutPop.status === 'open'">
                    {{ "calendar.pop.status_off" | translate }}
                    <!-- 关闭 -->
                  </div>
                  <div class="item" (click)="displayEditNotePop = true">
                    {{ "calendar.pop.add_note" | translate }}
                    <!-- 备注 -->
                  </div>
                </ng-container>

                <!-- 新建任务 -->
                <div
                  class="item"
                  *ngIf="selectedCellDates.head.isSame(selectedCellDates.last, 'd')"
                  (click)="createTask($event, selectedCellDates.head.format('YYYY-MM-DD'), listOfSelectedData.id)">
                  {{ "calendar.pop.new_task" | translate }}
                </div>
              </div>
              <div class="arrow"></div>
            </div>
          </div>
          <!-- 编辑备注 -->
          <div
            *ngIf="displayEditNotePop && dataOfEditNotePop['id'] === house.c_id"
            class="edit-note-pop"
            [style.left]="cellWidth * dataOfEditNotePop.index + cellWidth / 2"
            nz-popover
            [nzPopoverVisible]="true"
            [nzPopoverTitle]="''"
            [nzPopoverContent]="editNoteContent"></div>
          <!-- 加载占位符 - 左 -->
          <div class="pr-2" [style.width]="cursor * cellWidth">
            <div class="h-[5px] w-full bg-c-gb rounded mt-[34px] animate-pulse"></div>
          </div>
          <!-- 日历格子 -->
          <div
            *ngFor="let date of listOfDatesInView; trackBy: trackDate; let i = index"
            class="body-cell"
            [ngClass]="{
              '!border-l-[#ced5df]': date.day === 0,
              '!border-l-[#48ca93]': date.isCurrentDay,
              'bg-[url(/assets/calendar/shadow.png)] bg-[length:100%_100%] bg-no-repeat':
                [-3, -1, 0].indexOf(calendarMap[house.c_id]?.[date.date]?.available) !== -1,
              'bg-[#f3f3f3]': calendarMap[house.c_id]?.[date.date]?.available === -2
            }"
            [ngStyle]="{ width: cellWidth }"
            (click)="onClickCell(house, date)"
            (mouseenter)="onHoverCell(house, date)">
            <div class="right-icon-wrapper">
              <!-- 备注 -->
              <div
                *ngIf="calendarMap[house.c_id]?.[date.date]?.note"
                nz-popover
                nzTrigger="hover"
                [nzPopoverTitle]="''"
                [nzPopoverContent]="notePopTpl"
                class="note"></div>
              <!-- 超售 -->
              <div
                *ngIf="housesOversaleMap['house']?.[house.c_id]?.[date.date]"
                nz-popover
                nzTrigger="hover"
                [nzPopoverTitle]="''"
                [nzPopoverContent]="houseOversaleTpl"
                class="oversale"></div>
              <!-- 房态不一致 -->
              <div
                *ngIf="calendarMap[house.c_id]?.[date.date]?.available === -1"
                nz-popover
                nzTrigger="hover"
                [nzPopoverTitle]="''"
                [nzPopoverContent]="exclamationPopTpl"
                class="exclamation"></div>
              <!-- 小时单 -->
              <div
                *ngIf="hourReservationMap[house.c_id]?.[date.date]?.length"
                (click)="onClickHourOrder($event, hourReservationMap[house.c_id][date.date], date.date)"
                class="hour-reservation"
                [class.selected]="isHourReservationSelected(house.c_id, date.date)"></div>
              <!-- 任务 -->
              <div
                class="task"
                style="line-height: 1"
                *ngIf="taskMap[house.c_id]?.[date.date]?.length"
                (click)="onClickTask($event, taskMap[house.c_id][date.date])"></div>
              <!--停用-->
              <div class="stop-status" *ngIf="calendarMap[house.c_id]?.[date.date]?.available === -3"></div>
            </div>

            <!-- 规则图标 -->
            <div
              class="rules-icons"
              nz-popover
              [nzPopoverTitle]="null"
              [nzPopoverContent]="rulePopTpl"
              *ngIf="
                displayLeadRules &&
                !calendarMap[house.c_id]?.[date.date]?.reservation &&
                calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting
              ">
              <div class="rules-item" *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.showMoon">
                <img class="rules-icon" src="/assets/v4/icon-calendar-moon.svg" alt="" />
                <span
                  *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.moonCount as moonCount"
                  class="text-[10px] text-[#586167]"
                  >{{ moonCount }}</span
                >
              </div>
              <div class="rules-item" *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.showLock">
                <img class="rules-icon" src="/assets/v4/icon-calendar-lock.svg" alt="" />
              </div>
              <div class="rules-item" *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.showFlag">
                <img class="rules-icon" src="/assets/v4/icon-calendar-flag.svg" alt="" />
              </div>
            </div>

            <!-- 价格 -->
            <div *ngIf="displayLeadPrice" class="text-[12px] text-[#34383c]">
              {{ calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.price }}
            </div>

            <!-- 备注模板 -->
            <ng-template #notePopTpl>
              <host-auto-popover
                type="note"
                [noteText]="calendarMap[house.c_id][date.date]?.note"
                (onClickEditNote)="
                  updateDataOfEditNotePop([calendarMap[house.c_id][date.date]]); displayEditNotePop = true
                "></host-auto-popover>
            </ng-template>

            <!-- 房态不一致模板 -->
            <ng-template #exclamationPopTpl>
              <host-auto-popover
                type="status-diff"
                [statusDiffList]="{
                  '0': calendarMap[house.c_id][date.date]?.closed_thirdparty,
                  '1': calendarMap[house.c_id][date.date]?.open_thirdparty
                }"></host-auto-popover>
            </ng-template>

            <!-- 超售模板 -->
            <ng-template #houseOversaleTpl>
              <host-auto-popover
                type="oversale"
                [oversaleMap]="housesOversaleMap['house'][house.c_id][date.date]"
                (onClickEditOversale)="
                  toPropertyDetailPage({
                    queryParams: { id: house.c_id, subTab: 1 }
                  })
                "></host-auto-popover>
            </ng-template>

            <ng-template #rulePopTpl>
              <div>
                <!-- 规则-月亮 -->
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.min_stay_on_arrival as min_soa">
                  {{ "calendar-rules_min_stay_on_arrival" | translate }}
                  <!-- Min stay on arrival: -->
                  {{ min_soa }}
                </div>
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.min_stay_through as min_st">
                  {{ "calendar-rules_min_stay_through" | translate }}
                  <!-- Min stay through: -->
                  {{ min_st }}
                </div>
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.max_stay_on_arrival as max_soa">
                  {{ "calendar-rules_max_stay_on_arrival" | translate }}
                  <!-- Max stay on arrival: -->
                  {{ max_soa }}
                </div>
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.max_stay_through as max_st">
                  {{ "calendar-rules_max_stay_through" | translate }}
                  <!-- Max stay through: -->
                  {{ max_st }}
                </div>
                <div
                  *ngIf="
                    calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.exact_stay_on_arrival as exact_soa
                  ">
                  {{ "calendar-rules_exact_stay_on_arrival" | translate }}
                  <!-- Exact stay on arrival: -->
                  {{ exact_soa }}
                </div>
                <!-- 锁 -->
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.closed_on_arrival as coa">
                  {{ "calendar-rules_closed_on_arrival" | translate }}
                  <!-- Closed on arrival: -->
                  {{ coa ? "Enabled" : "Disabled" }}
                </div>
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.closed_on_departure as cod">
                  {{ "calendar-rules_closed_on_departure" | translate }}
                  <!-- Closed on departure: -->
                  {{ cod ? "Enabled" : "Disabled" }}
                </div>
                <!-- 旗子 -->
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.min_advance_res as min_ar">
                  {{ "calendar-rules_min_advance_res" | translate }}
                  <!-- Min advance res: -->
                  {{ min_ar }}
                </div>
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.max_advance_res as max_ar">
                  {{ "calendar-rules_max_advance_res" | translate }}
                  <!-- Max advance res: -->
                  {{ max_ar }}
                </div>
                <div *ngIf="calendarMap[house.c_id]?.[date.date]?.prices?.[0]?.setting?.seasonal_rule as sr">
                  {{ "calendar-rules_seasonal_rule" | translate }}
                  <!-- Seasonal rule: -->
                  {{ sr }}
                </div>
              </div>
            </ng-template>
          </div>
          <!-- 加载占位符 - 右 -->
          <div class="pl-2 flex-1">
            <div class="h-[5px] w-full bg-c-gb rounded mt-[34px] animate-pulse"></div>
          </div>
          <!-- 编辑备注模板 -->
          <ng-template #editNoteContent>
            <host-auto-popover
              type="note-edit"
              [noteText]="dataOfEditNotePop.text"
              (onClickConfirmEditNote)="onSaveEditNote($event)"
              (onClickCancelEditNote)="onCancelEditNote()"></host-auto-popover>
          </ng-template>

          <!-- 选择框 -->
          <div
            *ngIf="selectStatus !== 'none' && listOfSelectedData['id'] === house.c_id"
            class="select-rect"
            [ngStyle]="selectedRectStyle"></div>

          <div
            class="change-order-house-rect"
            [ngStyle]="changeOrderBelongedHouseRectStyle"
            *ngIf="
              changeOrderBelongedHouseData?.houseId !== house.c_id &&
              changeOrderBelongedHouseStatus === 'selecting' &&
              !changeOrderBelongedHouseConflictMap[house.c_id]
            "
            (click)="changeOrderBelongedHouse(house.c_id)"></div>
        </div>
      }
    }
  </ng-template>
</host-calendar-layout>

<!-- pagination -->
<div class="absolute bottom-[30px] right-[30px]">
  <ng-content></ng-content>
</div>

<!-- empty   -->
<div class="empty-container">
  <ng-content select=".empty-content"></ng-content>
</div>
